module.exports = __webpack_public_path__ + "img/winter.e405202d.jpg";